module.exports = __webpack_public_path__ + "img/state_icon.fb343efe.svg";